import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import AnimatedPage from '../AnimatedPage/AnimatedPage';

import Instructor_card from './Instructor_card';
import PlaceHolder from '../Courses/placeholder';
import "./instructor.css"
import { UserDataContext } from '../UserContext/UserContext'

export default function Instructors() {
    const [instructors, setInstructors] = useState([]);
    const [loading, setLoading] = useState(true);
    let {Base_url}=useContext(UserDataContext)

    useEffect(() => {
        async function fetchInstructors() {
            try {
                const response = await axios.get(`${Base_url}/instructors/`);
                setInstructors(response.data);
                setLoading(false);
            } catch (error) {
                setLoading(true);
            }
        }
        fetchInstructors();
    }, [])



   
    return (
        <>
            {/* <Navbar /> */}
            <AnimatedPage>
            <div id="instructor" className='instructors-parent' data-aos="fade-up">
                <div className='container'>
                    <div className='instructorsHeader'>
                        <h2 className='text-center instructorsTitle'>Our Instructors</h2>
                        <p className='text-center text-muted instructorsSubtitle'>
                            Learn from experienced instructors who explain concepts clearly and practically.
                        </p>
                    </div>

                    {loading ? (
                        <div className='d-flex justify-content-center align-items-center'>
                            <PlaceHolder/>
                        </div>
                    ) : (
                        <Instructor_card instructors={instructors}/>
                    )}
                </div>
            </div>

            </AnimatedPage>
        </>
    );
}